<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 390.4 434">
    <path d="M385,275.6c-3.2-38.1-44.6-56.7-90-64.8c-38.6-6.9-78.5-14.3-110.3-35.7c-19.5-13.2-35-31-47.7-50
      c-11.8-17.6-21.9-36.9-39.2-49.9c-12.9-9.7-29-15.1-45.3-17.8C35.1,54.5,17.3,54.7,0,57.9v313.5c75.8,78.3,166.8,6,255,0.1
      C343.3,365.6,388.2,313.7,385,275.6z" fill="#D0DEDC"/>
    <path d="M273.5,328.7c-3.3-13.5-8.9-24.4-10.5-27.5c-4.5-8.4-18-28-41.3-56.3h0c0,0,0,0-0.1-0.1c-1-1.2-2.1-2.5-3.1-3.8l0,0
      c-4.8-5.9-9-12.3-12.7-19c-10.3-19.7-12.8-42.5-15.3-64.5c-0.6-5.1-1.1-10.4-1.8-15.5c-5.2-39.5-20-92.7-61.3-121.8
      C115.5,12,102.1,6.1,87.9,3C73.6-0.1,59-0.8,44.5,0.8C29.2,2.5,14.2,6.4,0,12.5v2.3C39.9-2.2,88.5-4.5,126.2,22
      c40.7,28.7,55.4,81.3,60.5,120.4c0.7,5.1,1.3,10.4,1.8,15.5c2.5,22.3,5,45.3,15.5,65.3c3.7,6.8,8,13.3,12.9,19.3l0,0
      c25.2,30.2,39.6,51.1,44.3,59.8c1.6,3,7.1,13.7,10.3,27c4,16.4,3.2,30.3-2.4,41.2c-7.7,14.8-24.2,23.8-49.1,26.9
      c-41.1,5-62.6,12.6-81.5,19.3c-20.7,7.3-38.5,13.6-76.1,15.1c-19.9,0.8-40.6-9.1-61.5-29.4c-0.3-0.3-0.5-0.5-0.8-0.8v2.9
      C20.3,424.1,40.5,434,60.1,434c0.8,0,1.6,0,2.3,0c37.8-1.5,55.8-7.9,76.7-15.3c18.9-6.7,40.2-14.2,81.1-19.2
      c25.7-3.1,42.7-12.6,50.7-28C276.8,360.1,277.7,345.7,273.5,328.7z" />
  </svg>
</template>

<script>
export default {
  name: 'SvgForm1'
}
</script>
